import { useEffect, useMemo, useState } from 'react';
import { setSelectedAccount as setSelectedAccountAction, useAppDispatch } from '@ibk/shared-config';
import { useGetPersonAccessesQuery } from '../services/person-access';
import { useAuth } from './useAuth';
export function usePersonAccess() {
    const { isAuthenticated } = useAuth();
    const [data, setData] = useState(null);
    const { data: response, isLoading, isError, error: queryError, refetch: getCompanies, } = useGetPersonAccessesQuery(undefined, {
        skip: !isAuthenticated,
        refetchOnMountOrArgChange: true,
        refetchOnFocus: true,
        refetchOnReconnect: true,
    });
    const refetch = () => {
        setData(response?.result || null);
        getCompanies();
    };
    useEffect(() => {
        setData(response?.result || null);
    }, [response?.result]);
    const error = useMemo(() => {
        if (!isError)
            return null;
        if (queryError && 'data' in queryError) {
            const errorData = queryError.data;
            return errorData?.message || 'Erro ao buscar dados de acesso.';
        }
        return 'Erro desconhecido ao buscar dados de acesso.';
    }, [isError, queryError]);
    return {
        data,
        loading: isLoading,
        error,
        refetch,
    };
}
export function useSelectedAccount() {
    const dispatch = useAppDispatch();
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const loadSelectedAccount = async () => {
            try {
                setLoading(true);
                const { getSelectedAccountInfo } = await import('../utils/personAccessStorage');
                const accountInfo = getSelectedAccountInfo();
                setSelectedAccount(accountInfo);
                dispatch(setSelectedAccountAction(accountInfo));
            }
            catch (error) {
                console.error('Error loading selected account:', error);
                setSelectedAccount(null);
            }
            finally {
                setLoading(false);
            }
        };
        loadSelectedAccount();
    }, []);
    return {
        selectedAccount,
        loading,
        hasSelectedAccount: selectedAccount !== null,
        refresh: () => {
            setLoading(true);
            import('../utils/personAccessStorage').then(({ getSelectedAccountInfo }) => {
                const accountInfo = getSelectedAccountInfo();
                setSelectedAccount(accountInfo);
                dispatch(setSelectedAccountAction(accountInfo));
                setLoading(false);
            });
        },
    };
}
